<script context="module">
  import { writable } from 'svelte/store'

  const CHNAGE_PLAN_VIEW = {
    HOME: '',
    CONFIRM_CHANGE: 'confirmChange',
    CONFIRM_CANCEL: 'confirmCancel',
  }

  const changePlanView = writable(CHNAGE_PLAN_VIEW.HOME)
</script>

<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import type { Inventory, Membership, MembershipsPayload, MembershipByEmailPayload, ReadableQuery } from '../../api'
  import { tab, TAB } from '../../elements'
  import { selectedProduct } from '../store'
  import ViewChangeMembership from './ViewChangeMembership.svelte'
  import ViewConfirmCancel from './ViewConfirmCancel.svelte'
  import ViewConfirmChange from './ViewConfirmChange.svelte'

  export let membership: Membership
  export let inventories: Inventory[]
  export let activeMembershipQuery: ReadableQuery<MembershipsPayload | MembershipByEmailPayload>
  export let userCountry

  const dispatch = createEventDispatcher()

  function resetChangePlanView() {
    changePlanView.set(CHNAGE_PLAN_VIEW.HOME)
  }

  function backToInfoPanel() {
    resetChangePlanView()
    tab.set(TAB.INFO)
  }
</script>

{#if $changePlanView === CHNAGE_PLAN_VIEW.HOME}
  <ViewChangeMembership
    {activeMembershipQuery}
    {inventories}
    {membership}
    {userCountry}
    on:cancel={() => changePlanView.set(CHNAGE_PLAN_VIEW.CONFIRM_CANCEL)}
    on:change={({ detail: product }) => {
      changePlanView.set(CHNAGE_PLAN_VIEW.CONFIRM_CHANGE)
      selectedProduct.set(product)
    }}
    on:completeVipRedemption={() => {
      dispatch('notify', { isVip: true })
      selectedProduct.set({ isVip: true })
      backToInfoPanel()
    }}
  />
{:else if $changePlanView === CHNAGE_PLAN_VIEW.CONFIRM_CHANGE}
  <ViewConfirmChange
    immediateChange
    selectedProduct={$selectedProduct}
    {membership}
    {activeMembershipQuery}
    on:confirm={() => {
      dispatch('notify', { isVip: false })
      backToInfoPanel()
    }}
    on:cancel={resetChangePlanView}
  />
{:else if $changePlanView === CHNAGE_PLAN_VIEW.CONFIRM_CANCEL}
  <ViewConfirmCancel
    {inventories}
    {membership}
    {activeMembershipQuery}
    on:confirm={backToInfoPanel}
    on:cancel={resetChangePlanView}
  />
{/if}
